import React, { Component } from 'react'
import DayPicker from 'react-day-picker'
import moment from 'moment'
import SmoothCollapse from 'react-smooth-collapse'
import { withRouter } from 'react-router'
import Icon from 'components/icon/icon'
import { connect } from 'react-redux'
import Button from 'components/button/button'

import {
	saveItem,
	deleteItem,
	openModal,
	setOnboardingStep
} from 'state/actions'

import GuestList from 'components/modal/modal-components/guest-list'

import MainHeaderNav from 'sections/main-header-nav'

import {
	getCurrentAccount,
	getAllGuests,
	getUserRoles
} from 'state/selectors'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'
import { stringIsEmpty } from 'utils'

import FolderSelector from '../modal-components/folder-selector'

import { find, filter, forIn } from 'lodash'
import copy from 'fast-copy'

import InputStandard from 'components/input/standard'
import FeatureSelector from 'components/feature-selector/feature-selector'
import Checkbox from 'components/input/checkbox'

import {
	hasReachedProjectQuota,
	isMobile,
} from 'utils'

class ModalProject extends Component {
	constructor(props) {
		super(props)

		this.state = {
			start_date: '',
			end_date: '',
			account_id: '',
			folderChain: [],
			guestInputValue: '',
			includedGuestEmails: [],
			includedTeamIds: [],
			guestList: [],
			teamList: [],
			name: '',
			isParentSelectorOpen: false,
			currentTab: 0,
			has_gantts: false,
			has_timing: false,
			is_public: true,
			restrict_guest_visibility: false,
			columns: [],
			duplicate_retain_task_content: false,
		}

		this.navtabs = [
			{
				name: 'Details',
			},
			{
				name: 'Access',
			}
		]
	}

	isOverQuota = false

	UNSAFE_componentWillMount = _ => {
		const {
			accountData,
			allProjects,
			openModal
		} = this.props

		this.isOverQuota = hasReachedProjectQuota(accountData, allProjects)

		if (this.isOverQuota) {
			openModal('pricing', 'pricing', {
				feature: 'projects'
			})
		}
	}

	seedColumns = _ => {
		// type, order, is_primary
		return [
			{
				id: -1,
				type: 'PEOPLE',
				order: 0,
				custom_name: null,
				is_primary: 1
			}, {
				id: -2,
				type: 'STATUS',
				order: 1,
				custom_name: null,
				is_primary: 1
			}, {
				id: -3,
				type: 'DATE',
				order: 2,
				is_primary: 1,
				custom_name: null
			}
		]
	}

	componentDidMount() {
		const {
			data,
			allGuests,
			allGuestInvitations,
			accountData,
			allTeams,
			folderChain,
			allFolders,
			userRoles,
			currentUser
		} = this.props

		setTimeout(_ => {
			if (this.refs.projectName && this.refs.projectName.inputRef) {
				this.refs.projectName.inputRef.focus()
			}
		}, 1)

		let projectId = null

		// Guest list
		let tempGuestListArray = []
		let tempTeamListArray = []
		let includedTeamIds = []

		allGuests.forEach(guest => {
			tempGuestListArray.push(guest)
		})

		forIn(allGuestInvitations, invitation => {
			if (invitation.account_id == accountData.id) {
				tempGuestListArray.push(invitation)
			}
		})

		forIn(allTeams, team => {
			let shouldPushTeam = false

			if (userRoles.admin || userRoles.pm) {
				shouldPushTeam = true
			} else {
				if (team.userIds.indexOf(currentUser.id) !== -1) {
					shouldPushTeam = true
				}
			}

			if (team.account_id == accountData.id && shouldPushTeam) {
				tempTeamListArray.push(team)
			}
		})

		const existingProject = data

		let columns = []

		if (existingProject && existingProject.id) {
			if (existingProject.id) {
				projectId = existingProject.id
			}

			if (existingProject.teamIds) {
				existingProject.teamIds.forEach(id => {
					const team = allTeams[id]

					if (projectId) {
						if (!team) {
							return
						}

						if (team.projectIds.indexOf(projectId) !== -1) {
							includedTeamIds.push(team.id)
						}
					}
				})
			}

			columns = existingProject.columns
		} else {
			columns = this.seedColumns()
		}

		let tempState = {
			...existingProject,
			name: existingProject.name ? existingProject.name : '',
			account_id: accountData.id,
			folderChain,
			guestList: tempGuestListArray,
			teamList: tempTeamListArray,
			includedTeamIds,
			columns
		}

		if(!existingProject.id && window.isTkb){
			tempState.has_gantts = true
			tempState.has_timing = true
		}

		if (!data.folder_id) {
			tempState.folder_id = allFolders[folderChain[(folderChain.length - 1)]].id
		} else {
			tempState.folder_id = data.folder_id;
		}

		if (data.duplicate) {
			const folderIfExists = allFolders[tempState.folder_id]

			if (!folderIfExists) {
				tempState.folder_id = folderChain[0]
			}

			tempState.name += ' (copy)'
		}

		let tempIncludedGuestEmails = []

		if (data.guestIds) {
			data.guestIds.forEach(id => {
				const guest = allGuests.find(guest => {
					return guest.id == id;
				})

				if (guest) {
					tempIncludedGuestEmails.push(guest.email)
				}
			})

			data.invitationIds.forEach(id => {
				const invitedGuest = allGuestInvitations.find(invitation => {
					return invitation.id == id;
				})

				if (invitedGuest) {
					tempIncludedGuestEmails.push(invitedGuest.recipient_email)
				}
			})

			tempState.includedGuestEmails = tempIncludedGuestEmails
		}

		this.randomProjectName = this.getRandomProjectName()

		this.setState(tempState)
	}

	openDatepicker = (proxy, type) => {
		proxy.stopPropagation()

		const {
			modalState,
			dismissDatepicker,
			openMenuCallback
		} = this.props

		if (modalState.currentOpenMenu == type) {
			dismissDatepicker()
		} else {
			openMenuCallback(type)
		}
	}

	handleDateChange = (date, type) => {
		const {
			end_date,
			start_date
		} = this.state

		if (type === 'start_date') {
			if (end_date && moment(date).isAfter(moment(end_date))) {
				return null
			}

			const oldDate = start_date

			const newDate = moment(date).format('Y-MM-DD')

			this.setState({
				start_date: oldDate !== newDate ? moment(date).format('Y-MM-DD') : null
			})
		} else if (type === 'end_date') {
			if (start_date && moment(date).isBefore(moment(start_date))) {
				return null
			}

			const oldDate = this.state.end_date

			const newDate = moment(date).format('Y-MM-DD')

			this.setState({
				end_date: oldDate !== newDate ? moment(date).format('Y-MM-DD') : null
			})
		}

		this.props.dismissDatepicker()
	}

	handleSubmit = _ => {
		const {
			isLoading,
			setLoading,
			data,
			deleteItem,
			saveItem,
			currentUser,
			handleError,
			closeCallback,
			history,
			accountData,
			setOnboardingStep
		} = this.props

		const {
			guestInputValue,
		} = this.state

		if (isLoading) {
			return
		}

		if (guestInputValue) {
			return handleError(`Click the + button to add "${guestInputValue}" as a guest.`)
		}

		const {
			name,
			duplicate
		} = this.state

		const requestData = {
			...this.state,
			user_id: currentUser.id
		}

		if (stringIsEmpty(name)) {
			return handleError('Please enter a project name.')
		}

		setLoading(true)

		// detach the project, in case the parent folder has changed.
		if (data && data.id && !duplicate) {
			deleteItem('project', this.props.data, null, null, true)
		}

		saveItem(requestData, 'project', newProject => {
			closeCallback()

			setOnboardingStep('CREATED_PROJECT', currentUser)

			history.push(`/${accountData.slug}/projects/${newProject.slug}/tasks`)
		})
	}

	handleChange = (value, input) => {
		let currentState = copy(this.state)

		currentState[input] = value

		this.setState({
			...currentState,
		})
	}

	handleChangeGuests = guest => {
		let email = guest.email ? guest.email : guest.recipient_email
		let externalEmails = copy(this.state.includedGuestEmails)

		const indexIfExists = externalEmails.findIndex(loopedEmail => {
			return loopedEmail == email
		})

		if (indexIfExists < 0) {
			externalEmails.push(email)
		} else {
			externalEmails.splice(indexIfExists, 1)
		}

		this.setState({
			includedGuestEmails: externalEmails
		})
	}

	handleChangeTeams = team => {
		let includedTeamIds = copy(this.state.includedTeamIds)

		const indexIfExists = includedTeamIds.findIndex(teamId => {
			return teamId == team.id
		})

		if (indexIfExists == -1) {
			includedTeamIds.push(team.id)
		} else {

		}
	}

	handleIncludedChange = (item, type) => {
		let checkValue = null
		let checkKey = null
		let tempState = {}

		switch (type) {
			case 'teams':
				checkValue = item ? item.id : null
				checkKey = 'includedTeamIds'
				break
			case 'guest':
				checkValue = item.email ? item.email : item.recipient_email
				checkKey = 'includedGuestEmails'
				break
		}

		let tempArray = copy(this.state[checkKey])

		if (checkValue) {
			const indexIfExists = tempArray.findIndex(loopedValue => {
				return loopedValue == checkValue
			})

			if (indexIfExists < 0) {
				tempArray.push(checkValue)
			} else {
				tempArray.splice(indexIfExists, 1)
			}

			if (type == 'teams') {
				tempState.is_public = false
			}
		} else {
			tempArray = []

			if (type == 'teams') {
				tempState.is_public = !this.state.is_public
			}
		}

		tempState[checkKey] = tempArray

		this.setState(tempState)

	}

	addNewGuest = _ => {
		const {
			accountData,
			allUsers,
			handleError
		} = this.props

		const {
			guestInputValue,
			guestList
		} = this.state

		let isValid = true
		let skipAddToGuestList = false
		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		if (!guestInputValue) {
			isValid = false
		}

		const includedGuestEmails = copy(this.state.includedGuestEmails)

		if (find(accountData.users, userId => {
			const userObject = allUsers[userId]

			if (userObject && userObject.email.toLowerCase() === guestInputValue.toLowerCase()) {
				// so there is a user - but are they a guest?
				return accountData.guestIds.indexOf(userObject.id) === -1
			}

			return false
		})) {
			handleError('This user is not a guest.')
			isValid = false;
		} else if (find(guestList, guest => {
			return guest.email == guestInputValue
		})) {
			// this fucks up with an unconfirmed invitation
			if (includedGuestEmails.find(includedEmail => {
				return includedEmail == guestInputValue
			})) {
				handleError('You\'ve already invited this person.')
				isValid = false
			} else {
				skipAddToGuestList = true
			}

		} else if (!re.test(String(guestInputValue).toLowerCase())) {
			handleError('That email seems invalid.')
			isValid = false;
		}

		if (isValid) {
			const newGuestList = copy(guestList)

			includedGuestEmails.push(guestInputValue)

			if (!skipAddToGuestList) {
				newGuestList.push({
					email: guestInputValue
				})
			}

			this.setState({
				guestList: newGuestList,
				includedGuestEmails,
				guestInputValue: ''
			})
		}
	}

	toggleMenu = _ => {
		this.setState({
			isParentSelectorOpen: !this.state.isParentSelectorOpen
		})
	}

	forceCloseMenu = _ => {
		this.setState({
			isParentSelectorOpen: false
		})
	}

	changeParent = folder_id => {
		this.setState({
			folder_id,
			isParentSelectorOpen: false
		})
	}

	removeGuest = guestToRemove => {
		const guestEmail = guestToRemove.email ? guestToRemove.email : guestToRemove.recipient_email

		const currentGuestIds = filter(this.state.guestList, guest => {
			const comparisonValue = guest.email ? guest.email : guest.recipient_email;
			return comparisonValue !== guestEmail;
		})

		const includedGuestEmails = filter(this.state.includedGuestEmails, email => {
			return guestEmail !== email
		})

		this.setState({
			guestList: currentGuestIds,
			includedGuestEmails
		})
	}

	getInitialMonth = type => {
		const {
			start_date,
			end_date
		} = this.state

		switch (type) {
			case 'start':
				if (start_date) {
					return new Date(start_date)
				} else if (end_date) {
					return new Date(end_date)
				}
				break
			case 'end':
				if (end_date) {
					return new Date(end_date)
				} else if (start_date) {
					return new Date(start_date)
				}
				break
		}

		return new Date()
	}

	changeTab = tab => {
		let tabIndex = this.navtabs.findIndex(loopedTab => {
			return loopedTab.name === tab.name
		})

		this.setState({
			currentTab: tabIndex,
		})
	}

	toggleFeature = feature => {
		let tempState = copy(this.state)
		tempState[feature.key] = !tempState[feature.key]

		this.setState(tempState)
	}

	handleKeepDuplicateDataChange = _ => {
		this.setState({
			duplicate_retain_task_content: !this.state.duplicate_retain_task_content
		})
	}

	getRandomProjectName = _ => {
		const { currentUser } = this.props
        const placeholders = [
            `${ currentUser.first_name }'s brilliant new idea`,
            `${ currentUser.first_name }'s favourite client`,
			`${ currentUser.first_name } changes the world`,
        ]

        return placeholders[Math.floor(Math.random() * placeholders.length)]
	}

	render() {
		const {
			includedGuestEmails,
			guestInputValue,
			isParentSelectorOpen,
			folder_id,
			start_date,
			end_date,
			name,
			currentTab,
			guestList,
			teamList,
			includedTeamIds,
			is_public,
			duplicate,
			duplicate_retain_task_content
		} = this.state

		const {
			data,
			closeCallback,
			validateResponse,
			handleDismiss,
			modalState,
			accountData,
		} = this.props

		const forceType = (data && data.forceType) ? data.forceType : null 

		const isNew = !data || !data.id

		this.navtabs.forEach(tab => {
			tab.isActive = false
		})

		if (this.navtabs.length) {
			this.navtabs[currentTab].isActive = true
		}

		let className = 'modal-new-project clear'

		const tempGuestList = [...guestList]

		tempGuestList.sort((a, b) => {
			const aEmail = (a.email || a.recipient_email || 'zzz').toLowerCase().trim()
			const bEmail = (b.email || b.recipient_email || 'zzz').toLowerCase().trim()

			if (aEmail < bEmail) return -1
			if (aEmail > bEmail) return 1
			return 0
		})

		tempGuestList.sort((a, b) => {
			const aEmail = a.email ? a.email : a.recipient_email
			const bEmail = b.email ? b.email : b.recipient_email

			const aChecked = includedGuestEmails.indexOf(aEmail) !== -1
			const bChecked = includedGuestEmails.indexOf(bEmail) !== -1

			return (aChecked === bChecked) ? 0 : aChecked ? -1 : 1
		})

		const tempTeamList = [
			...teamList
		]

		tempTeamList.sort((a, b) => {
			const aChecked = includedTeamIds.indexOf(a.id) !== -1
			const bChecked = includedTeamIds.indexOf(b.id) !== -1

			return (aChecked === bChecked) ? 0 : aChecked ? -1 : 1
		})

		const folderId = data ? data.folder_id : null

		const titleVerb = data.duplicate ? 'Duplicate' : data.id ? 'Edit' : 'Create'
		const title = titleVerb + ' project'

		const featureList = [
			{
				title: 'Gantt charts?',
				body: `Interactive timeline showing what's happening, and when.`,
				key: 'has_gantts'
			}, {
				title: 'Time tracking?',
				body: 'Easy, one-click time tracking for all your tasks.',
				key: 'has_timing'
			}, {
				title: 'Restrict guest access?',
				body: `Only allow guests to see tasks they're assigned to, or tagged in.`,
				key: 'restrict_guest_visibility'
			}
		]

		const projectModalSections = {
			info: (
				<div className="new-project-left input-wrap">
					<InputStandard
						outlineOnFocus={true}
						ref="projectName"
						callback={null}
						value={name}
						onChange={e => { this.handleChange(e.target.value, 'name') }}
						placeholder={this.randomProjectName}
					/>
					<div className="dates-container clear">
						<div
							className={modalState.currentOpenMenu == 'start' ? 'button-proxy active' : 'button-proxy'}
							onClick={proxy => this.openDatepicker(proxy, 'start')}
						>
							<Icon name="fe-calendar" />
							{start_date ?
								moment(start_date).format('MMMM Do') :
								'Start date'
							}
							<Icon name="caret-down" />
							<div
								onClick={e => { e.stopPropagation() }}
								className="modal-datepicker"
							>
								<SmoothCollapse
									allowOverflowWhenOpen={true}
									expanded={modalState.currentOpenMenu == 'start'}
									heightTransition="0.15s ease"
								>
									<DayPicker
										onDayClick={day => { this.handleDateChange(day, 'start_date') }}
										selectedDays={new Date(start_date)}
										initialMonth={this.getInitialMonth('start')}
										firstDayOfWeek={1}
										disabledDays={end_date ? {
											after: new Date(end_date)
										} : null}
									/>
								</SmoothCollapse>
							</div>
						</div>
						<div
							className={modalState.currentOpenMenu == 'end' ? 'button-proxy active' : 'button-proxy'}
							onClick={proxy => this.openDatepicker(proxy, 'end')}
						>
							<Icon name="fe-calendar" />
							{end_date ?
								moment(end_date).format('MMMM Do') :
								'End date'
							}
							<Icon name="caret-down" />
							<div
								onClick={e => { e.stopPropagation() }}
								className="modal-datepicker"
							>
								<SmoothCollapse
									allowOverflowWhenOpen={true}
									expanded={modalState.currentOpenMenu == 'end'}
									heightTransition="0.15s ease"
								>
									<DayPicker
										onDayClick={day => { this.handleDateChange(day, 'end_date') }}
										selectedDays={new Date(end_date)}
										initialMonth={this.getInitialMonth('end')}
										firstDayOfWeek={1}
										disabledDays={start_date ? {
											before: new Date(start_date)
										} : null}
									/>
								</SmoothCollapse>
							</div>
						</div>
					</div>
					<FolderSelector
						isFolder={false}
						folderId={folderId}
						isOpened={isParentSelectorOpen}
						forceCloseMenu={this.forceCloseMenu}
						toggleMenu={this.toggleMenu}
						parentFolderChange={folderId => { this.changeParent(folderId) }}
						currentParentId={folder_id ? folder_id : null}
					/>
					{ duplicate &&
						<div className="form-row">
							<label
								className="domain-toggle"
								onClick={e => e.stopPropagation()}
							>
								<Checkbox
									isChecked={duplicate_retain_task_content}
									onChange={this.handleKeepDuplicateDataChange}
								/>
								<span>
									Also copy task data (e.g, comments, statuses, etc)
								</span>
							</label>
						</div>
					}
				</div>
			),
			features: (
				<div className="new-project-right input-wrap">
					<FeatureSelector
						featureList={featureList}
						featureState={this.state}
						toggleCallback={this.toggleFeature}
						canSelect={true}
					/>
				</div>
			),
			teams: (
				<div className="new-project-left input-wrap">
					<label>
						<strong>Teams</strong> in this project:
					</label>
					<GuestList
						users={tempTeamList}
						handleChangeUsers={team => { this.handleIncludedChange(team, 'teams') }}
						includedKeyArrays={[includedTeamIds]}
						checkKeys={['id']}
						isTeams={true}
						accountData={accountData}
						isPublic={is_public}
						canSelect={true}
					/>
				</div>
			),
			guests: (
				<div className="new-project-right input-wrap">
					<label>
						<strong>Guests</strong> in this project:
					</label>
					<div className="form-wrap">
						<InputStandard
							outlineOnFocus={true}
							callback={this.addNewGuest}
							value={guestInputValue}
							onChange={e => { this.handleChange(e.target.value, 'guestInputValue') }}
							placeholder="Enter a guest email address"
							showPlus={true}
							validate='email'
						/>
					</div>
					<GuestList
						users={tempGuestList}
						parentEntityId={this.props.data ? this.props.data.id : null}
						handleChangeUsers={guest => { this.handleIncludedChange(guest, 'guest') }}
						removeUser={this.removeGuest}
						includedKeyArrays={[includedGuestEmails]}
						checkKeys={['email', 'recipient_email']}
						isGuest={true}
						hasSearch={true}
						canSelect={true}
					/>
				</div>
			)
		}

		const canAdministrateTeams = !isMobile()

		if (this.isOverQuota) {
			className += ' block-click'
		}

		let tabContent = null

		const currentTabWithForcedTab = (() => {
			if(forceType){
				if(forceType === 'details'){
					return 0
				}

				return 1
			}else{
				return currentTab
			}
		})()

		switch (currentTabWithForcedTab) {
			case 0:
				tabContent = (
					<div>
						{projectModalSections.info}
						{canAdministrateTeams ? projectModalSections.features : projectModalSections.guests}
					</div>
				)
				break
			case 1:
				tabContent = (
					<div>
						{ projectModalSections.teams}
						{ projectModalSections.guests}
					</div>
				)
				break
		}

		return (
			<div className="has-tabs">
				<div className={className}>
					<div className="modal-tabs-heading">
						<h2>
							{title}
						</h2>
						<MainHeaderNav
							right={true}
							callback={this.changeTab}
							currentTab={currentTab}
							navtabs={(!isMobile() && !forceType) ? this.navtabs : null}
							type="settings-tabs"
						/>
					</div>
					{tabContent}
				</div>
				<ValidateResponse dismissCallback={handleDismiss} response={validateResponse} />
				<React.Fragment>
					<Button
						size={'big'}
						level={'high'}
						callback={this.handleSubmit}
						label={isNew ? 'Save' : 'Update'}
						icon={'check'}
						disabled={this.isOverQuota}
					/>
					<Button
						size={'big'}
						level={'low'}
						callback={closeCallback}
						label={'Cancel'}
					/>
				</React.Fragment>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		accountData: getCurrentAccount(state),
		folderChain: state.account.folderChain,
		operation: state.modal.operation,
		allGuestInvitations: filter(state.account.entities.invitations, invitation => {
			return invitation.is_guest && !invitation.completed && !invitation.is_invalidated;
		}),
		allGuests: getAllGuests(state),
		allUsers: state.account.entities.users,
		allFolders: state.account.entities.folders,
		allTeams: state.account.entities.teams,
		allProjects: state.account.entities.projects,
		currentUser: (state.auth && state.auth.userId) ? state.account.entities.users[state.auth.userId] : null,
		userRoles: getUserRoles(state),
	};
}

const ModalProjectWithValidateResponse = withValidateResponse(ModalProject)

export default withRouter(connect(mapStateToProps, {
	saveItem,
	deleteItem,
	openModal,
	setOnboardingStep
})(ModalProjectWithValidateResponse));